import { InputAdornment, TextField } from '@mui/material';

const TypePassword = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
}) => {
  function handleTextChange(value) {
    updateValidationOnChange([field.key], value.target.value);
  }
  return (
    <TextField
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
      size={size}
      label={field.label}
      type="password"
      value={dataCollection[field.key] || ''}
      onChange={handleTextChange}
      multiline={field.multiline ? true : false}
      InputProps={
        field.unit
          ? {
              endAdornment: (
                <InputAdornment position="end">{field.unit}</InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};

export default TypePassword;
